import { IRoute } from "@src/routes";
import QueryFixedDiscountRules from "./pages/QueryFixedDiscountRules";

import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/refund/fixed-discount-rule",
    key: "REFUND_QUERY_FIXED_DISCOUNT_RULES",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: QueryFixedDiscountRules,
  },
  {
    path: "/refund/fixed-discount-rule/:params",
    key: "REFUND_QUERY_RESULT_FIXED_DISCOUNT_RULES",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: QueryFixedDiscountRules,
  },
];

export default routes;
